import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { DataProvider } from "@/lib/dataStore";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import AppLayout from "@/pages/AppLayout";
import LogsPage from "@/pages/LogsPage";
import TaxPage from "@/pages/TaxPage";
import ProfitPage from "@/pages/ProfitPage";
import ReceiptPage from "@/pages/ReceiptPage";
import LedgerPage from "@/pages/LedgerPage";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-500 text-sm">
        Checking session…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }
  return <DataProvider>{children}</DataProvider>;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user && user !== false) return <Navigate to="/receipt" replace />;
  return children;
};

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/receipt" replace />} />
              <Route path="logs" element={<LogsPage />} />
              <Route path="tax" element={<TaxPage />} />
              <Route path="profit" element={<ProfitPage />} />
              <Route path="receipt" element={<ReceiptPage />} />
              <Route path="ledger" element={<LedgerPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
